import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { ACTION_PLANS_COMPANY_SUMMARY_TITLE } from './constants';

const ON_TRACK_THRESHOLD = 70;
const PERCENT_MAX = 100;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100px;
`;

const Percent = styled.span`
  font-size: 16px;
  font-family: var(--font-regular);
  font-weight: 400;
  color: var(--text-primary);
`;

const Progress = styled.progress`
  appearance: none;
  width: 100%;
  height: 3px;
  border: 0;
  border-radius: 4px;
  overflow: hidden;

  &::-webkit-progress-bar {
    background-color: var(--line-gray);
  }

  &::-webkit-progress-value {
    border-radius: 4px;
    background-image: linear-gradient(to right, var(--amber-light), var(--inactive-orange));
  }

  &::-moz-progress-bar {
    border-radius: 4px;
    background-image: linear-gradient(to right, var(--amber-light), var(--inactive-orange));
  }

  &.on-track::-webkit-progress-value {
    background-image: linear-gradient(to right, var(--mint-green), var(--positive-green));
  }

  &.on-track::-moz-progress-bar {
    background-image: linear-gradient(to right, var(--mint-green), var(--positive-green));
  }
`;

type Props = {
  percent: number;
  dataTestId?: string;
};

const ActionPlansCompanyProgressBar = ({ percent, dataTestId }: Props) => (
  <Container data-test-id={dataTestId}>
    <Percent>{percent}%</Percent>
    <Progress
      className={classNames({ 'on-track': percent >= ON_TRACK_THRESHOLD })}
      value={percent}
      max={PERCENT_MAX}
      aria-label={ACTION_PLANS_COMPANY_SUMMARY_TITLE.COMPLETION_RATE}
    />
  </Container>
);

export default ActionPlansCompanyProgressBar;
